import { http, HttpResponse } from 'msw';
import {
  getActivities,
  getClaims,
  getCustomers,
  getInsurances,
  getInvoices,
  getNotes,
  getQuotations,
  getTasks,
} from '@maia/shared';

function baseResponse<T>(response: T, page = 1, limit = 10) {
  return {
    statusCode: 200,
    response,
    success: true,
    error: null,
    pagination: {
      page_number: page,
      page_size: limit,
      total_results: 10,
      total_pages: 1,
    },
  };
}

export const handlers = [
  http.get('http://localhost:3000/customers', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const customers = getCustomers(limit);
    return HttpResponse.json(baseResponse(customers, page, limit));
  }),
  http.get('http://localhost:3000/customers/:guid', () => {
    const customer = getCustomers(1)[0];
    return HttpResponse.json(baseResponse(customer));
  }),
  http.get(
    'http://localhost:3000/customers/:guid/insurances',
    ({ request }) => {
      const url = new URL(request.url);
      const limit = parseInt(url.searchParams.get('limit') ?? '10');
      const insurances = getInsurances(limit);
      return HttpResponse.json(baseResponse(insurances));
    },
  ),
  http.get('http://localhost:3000/customers/:guid/claims', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const claims = getClaims(limit);
    return HttpResponse.json(baseResponse(claims));
  }),
  http.get(
    'http://localhost:3000/customers/:guid/activities',
    ({ request }) => {
      const url = new URL(request.url);
      const limit = parseInt(url.searchParams.get('limit') ?? '10');
      const activities = getActivities(limit);
      return HttpResponse.json(baseResponse(activities));
    },
  ),
  http.get('http://localhost:3000/customers/:guid/notes', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const notes = getNotes(limit);
    return HttpResponse.json(baseResponse(notes));
  }),
  http.get(
    'http://localhost:3000/customers/:guid/quotations',
    ({ request }) => {
      const url = new URL(request.url);
      const limit = parseInt(url.searchParams.get('limit') ?? '10');
      const quotations = getQuotations(limit);
      return HttpResponse.json(baseResponse(quotations));
    },
  ),
  http.get('http://localhost:3000/customers/:guid/tasks', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const tasks = getTasks(limit);
    return HttpResponse.json(baseResponse(tasks));
  }),
  http.get('http://localhost:3000/customers/:guid/invoices', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const invoices = getInvoices(limit);
    return HttpResponse.json(baseResponse(invoices));
  }),
];
